import * as Config from '../config';
import React, { useCallback, useContext } from "react";
import { ReactReduxContext } from 'react-redux';
import {
  addHistoryTracks,
  addReplayTracks,
  setOnAir,
  setPositionPreview,

  updateStorePlaylists,
  incrementStorePlaylists,

  addToast
  // setModal
} from "../actions/index";

import {
  emitSharedPlaylistPM
} from "../components/library/partymode/redux/actions/index";

// import ModalCTA from '../components/library/modal/ModalCTA';
// import ModalButton from '../components/library/modal/ModalButton';

const useCallbackPlay = (audio) => {
  const { store } = useContext(ReactReduxContext)
  const { getState, dispatch } = store

  const callback = useCallback( (_pid, source = null) => {
    const state = getState();

    if (source && source.disabled) { return; }
    if ( state.isWatcherPM && state.enablePM && state.inRoomPM ) {
      if (window['pm-warning']) {
        window['pm-warning'](null);
      }
    } else { // if (!state.isWatcherPM || !state.enablePM) {
      const track = (source) ? source : audio;

      // For Partymode - to avoid restricted tracks and blocking viewers
      // if (!track.available_worldwide && state.enablePM) {
      //   dispatch(setModal({
      //     content: (
      //       <ModalCTA
      //         title={`This track is not available worldwide`}
      //         description={`For a smooth set, this track is not allowed to load.`}
      //         styleDescription={{marginBottom: 10}}
      //         styleContainer={{marginTop: `-30%`, marginLeft: `-10%`}}
      //         classModal={`button-reduce`}
      //         styleBody={{gap: 26}}
      //       >
      //         <ModalButton label={`Close`} className={`primary`} />
      //       </ModalCTA>
      //     )
      //   }));
      //   return;
      // }

      dispatch(addHistoryTracks({ ...track, selected: false }));
      dispatch(addReplayTracks(track.id));
      dispatch(setOnAir(_pid, track.id));
      if (state.positionPreview.idParent === `history-tracks`) {
        state.playerPreview.pause();
        dispatch(setPositionPreview(null, 0));
      }
      const autoplay = (state.enablePM) ? state.enablePM : false; //PM
      let hlsEnabled = (state.isSubscribed && (track.is_available_for_streaming && !track.pre_order));
      if (track.is_dj_edit || (track.genre && track.genre.slug === 'dj-edits')) {
        hlsEnabled = track.dj_edit_allow;
      }
      state.api.loadAudio(_pid, track, autoplay, hlsEnabled);

      if (track.is_available_for_streaming === false) {
        dispatch(addToast({ content: <span>Download only, full-track streaming is unavailable.</span>, typeClass: 'warning', iconStyle: { padding: '32px 16px', marginRight: 16 } }));
      }
      if (track.pre_order) {
        dispatch(addToast({ content: <span>Preview only, full-track streaming available soon.</span>, typeClass: 'warning', iconStyle: { padding: '32px 16px', marginRight: 16 } }));
      }
      if (track.is_dj_edit && !track.dj_edit_allow && state.isSubscribed) { // Any account except free account
        dispatch(addToast({ content: <span>DJ Edits and Versions are only available in full with <a target="blank" href="https://www.beatport.com/subscriptions">Profesional+</a></span>, typeClass: 'warning', iconStyle: { padding: '24px 16px', marginRight: 16 } }));
      }

      // PartyMode - ONLY THE PERFORMER WHO BROADCAST
      const sharedPlaylist = (state.storePlaylists && state.storePlaylists.get) ? state.storePlaylists.get(Config.UID_SHARED_PLAYLIST) : null;
      if (sharedPlaylist) {
        dispatch(emitSharedPlaylistPM([track.id]));
        dispatch(updateStorePlaylists(Config.UID_SHARED_PLAYLIST, 'tracks', [...sharedPlaylist.tracks, {...track, selected: false}]))
        dispatch(incrementStorePlaylists(Config.UID_SHARED_PLAYLIST, `track_count`, sharedPlaylist.tracks.length));
      }

      // For Touch Mode
      if (state.layoutTablet && window.compact_mode_enable && window.compact_toggle) {
        window.compact_toggle();
      }
    }
  }, [audio, getState, dispatch]);

  return callback;
}

export default useCallbackPlay;
